import React from "react";
import { FooterNavLink, } from "./FooterNavLink/FooterNavLink";
export const FooterNavSection = ({ title, links }) => (React.createElement("section", { className: "footer-nav-section" },
    React.createElement("h5", { className: "footer-nav-section__title" }, title),
    React.createElement("ul", { className: "footer-nav-section__links" }, links.map((link, index) => (React.createElement("li", { key: index, className: "footer-nav-section__link" },
        React.createElement(FooterNavLink, { text: link.text, href: link.href, imageUrl: link.imageUrl, openInNewTab: link.openInNewTab })))))));
